import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../common/Modal'
import Component from '../common/Component'

export default class BulkPublishModal extends Component {
  static propTypes = {
    handleClose: PropTypes.func,
    handlePublish: PropTypes.func,
    isOpen: PropTypes.bool,
    disabled: PropTypes.bool
  }

  render() {
    if (!this.props.isOpen) { return null }

    return (
      <Modal
        className="bulk-publish-modal"
        handleClose={this.props.handleClose}
        isOpen={this.props.isOpen}
      >
        {this.props.children}
        <button
          className="select-button pure-button pure-input-1 pure-button-primary"
          type="button"
          disabled={this.props.disabled}
          onClick={this.props.handlePublish}
        >
          Publish
        </button>
      </Modal>
    )
  }
}
